export const setLayout = (context, payload) => {
  context.commit('setLayout', payload)
}
export const setTheme = (context, payload) => {
  context.commit('setTheme', payload)
}
export const setSidebar = (context, payload) => {
  context.commit('setSidebar', payload)
}
export const setMenu = (context, payload) => {
  context.commit('setMenu', payload)
}
export const setMenuOriginal = (context, payload) => {
  context.commit('setMenuOriginal', payload)
}
